import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const ITEMS = [
  {
    q: "Do I have to be on Xero to work with you?",
    a: "Only if you're a company. Companies keep their records in Xero — you'll need your own paid Xero subscription (our pricing does not include it). We're certified advisors and can help you pick a Xero plan and migrate across. Sole traders do not need Xero at all: we set you up on Prosaic and the Prosaic subscription is fully included in your monthly fee — we pay for it.",
  },
  {
    q: "What's Prosaic and why do you use it for sole traders?",
    a: "Prosaic is an accounting and bookkeeping platform built specifically for sole traders and contractors. It's lighter and cheaper than Xero for a single operator, and it can also raise simple sales invoices for your customers — handy for one-person operators who don't need a full accounts-receivable system. For sole traders, the Prosaic subscription is included in your NZ Taxation plan — you don't pay anything extra. You get access, we do the heavy lifting.",
  },
  {
    q: "What exactly is in the monthly tax position email?",
    a: "Your year-to-date income, deductible expenses, estimated tax owing, upcoming provisional tax dates, GST status (if registered), and any items in your ledger that need your attention. It's plain-English, with the key numbers at the top. We send it shortly after each month closes — no fixed day, but always once the month is finalised.",
  },
  {
    q: "I'm a sole trader just starting out. Is that okay?",
    a: "Absolutely — we have a Starter tier designed exactly for new sole traders. We'll set you up on Prosaic, classify income properly, and get you ready for your first end-of-year return. No Xero file needed.",
  },
  {
    q: "I'm signing up partway through the tax year — what does my subscription actually cover?",
    a: "Your subscription's tax-compliance scope is aligned with the NZ financial year you sign up in (NZ FY runs 1 April → 31 March). Example: if you sign up in June 2026 you're covered for FY2027 (1 Apr 2026 → 31 Mar 2027). We work through the months you stay subscribed within that year — there's no 12-month lock-in. Your prior year (FY2026) is NOT included by default because that period sits before your subscription starts. If FY2026 isn't filed yet, tick the 'Add prior-year catch-up' option at checkout — we'll prepare and file it as a one-off service equal to three months of your plan fee.",
  },
  {
    q: "Is this a long-term commitment? What happens if I cancel mid-year?",
    a: "No long-term lock-in. The plans are month-to-month — you only ever pay for the months you stay subscribed. Example: sign up in June 2026 and cancel in August 2026 → you're billed for June, July and August (three months) and that's it. You will NOT be billed through to May 2027. We align the scope with the NZ financial year purely so the tax-compliance work has a clean cycle; we deliver work for the months you paid for and stop when you stop. If you want us to file the full FY return at year-end, you'll need to be subscribed in March (or re-enrol before year-end) so we have the data and time.",
  },
  {
    q: "What if I cancel and then come back later in the same financial year?",
    a: "You're welcome back any time. However, if you'd like us to prepare the tax return covering the full original financial year (i.e. include the months you weren't subscribed), the missed months will need to be back-paid at the plan rate before we file. Reason: the return aggregates the entire FY, so we have to do the work for those months as well. Example: subscribed Jun–Aug 2026, cancelled, then re-enrol in Feb 2027 and want a full FY2027 return → you settle the Sep 2026–Jan 2027 months at your plan rate as part of re-enrolment, plus your ongoing monthly fee. If you don't need a full-year return covering the gap (e.g. you used a different accountant for that period or stopped trading), no back-pay applies — we just start fresh from re-enrolment.",
  },
  {
    q: "Can I switch tiers or cancel later?",
    a: "Yes — both. You can upgrade or downgrade any month, and you can cancel any month with no penalty. We finalise any work in progress for the month you cancel and stop billing from the next cycle.",
  },
  {
    q: "How do you handle IRD correspondence?",
    a: "We're registered tax agents. Once you're onboarded we link your IRD records to our agency, so we receive notices, can request extensions, and respond on your behalf.",
  },
  {
    q: "Is the price in NZD? Are there any setup fees?",
    a: "All prices on this page are NZD and GST-exclusive. No setup fees for standard onboarding. Companies: your Xero subscription is billed separately by Xero and is not included. Sole traders: your Prosaic subscription is fully included in your monthly plan. If you need a significant Xero clean-up, we'll quote that separately before starting.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">FAQ</div>
        <h2 className="mt-3 font-heading font-black text-4xl md:text-5xl tracking-tight leading-tight">
          Straight answers.
        </h2>

        <Accordion type="single" collapsible className="mt-10 border-t border-slate-200">
          {ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-slate-200"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-heading font-bold text-lg py-6 hover:no-underline hover:text-[#C9A349]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
